








import Vue from "vue";

export default Vue.extend({
  name: "LateFeesCard",
  props: {
    html: { type: String }
  }
});
